
import { Component, Prop, Vue, Watch, Emit } from "vue-property-decorator";
import Editor5 from "@/components/editor/classic-editor5.vue";
import UploadImg from "@/components/UploadImg-ai.vue";
import UploadImgBefore from "@/components/UploadImg-ai.vue";
import UploadImgAfter from "@/components/UploadImg-ai.vue";
import UploadVideo from "@/components/UploadVideo-ai.vue";
import draggable from "vuedraggable";
import RegisEdit from "../components/regis-edit.vue";
import Pop from "../components/blue-pop.vue";
import ExamList from "@/lib/model/exam/exam";
import Loading from "../../../components/loading.vue";
import SW from "@/components/form/switch.vue";
import mp3List from "@/lib/common/mp3";
import SetDiyPage from "../components/set-diy-page.vue";
import myCollapse from "@/views/ai-builder/step-view/components/myCollapse.vue";
import mySetup from "@/views/ai-builder/step-view/components/mySetup.vue";

import {
  ExamV2Custom,
  RegisInfo,
  Param,
  BeforeVideo
} from "@/lib/model/exambuilder/exam-v2";
import Auth from "@/lib/common/auth";
import ReportSet from "../config/reportSet.vue";
import { Params, Vir } from "@/lib/model/exambuilder/exam-component/company";
import dayjs from "dayjs";

class TestExamList {
  id = 0;
  name = "";
  connectCode = "";
}

@Component({
  components: {
    Editor5,
    UploadImg,
    draggable,
    RegisEdit,
    UploadVideo,
    Pop,
    Loading,
    UploadImgBefore,
    UploadImgAfter,
    SW,
    SetDiyPage,
    myCollapse,
    ReportSet,
    mySetup
  }
})
export default class SetOther extends Vue {
  @Prop({ type: ExamV2Custom, default: null }) exam!: ExamV2Custom; //考试Model
  @Prop({ type: Boolean, default: false }) isEdit!: boolean; //是否编辑页面
  @Prop({ type: Boolean, default: false }) isCandidateUsed!: boolean; //是否已有人作答
  @Prop({ default: [new Vir()] }) virList!: Vir[]; //虚拟人list
  @Prop({ default: false }) setWeb!: boolean; //内部使用 web配置

  deviceTestExample = require("@/assets/ai-builder/device-test-example.png");
  noiseDetectExample = require("@/assets/ai-builder/noise-detect-example.png");
  screenshotWarningExample = require("@/assets/ai-builder/screenshot-warning-example.png");
  jumpOutWarningExample = require("@/assets/ai-builder/jump-out-warning-example.png");
  defVir = new Vir(); //旧数据 id=0 用
  mp3List = mp3List; //音色列表
  selectData = 0;
  needValidation = false;
  datePickerOptions: any = {
    onPick: (obj: any) => {
      console.log(obj);
      this.selectData = obj.minDate?.getTime();
      if (obj.maxDate) {
        // 第二次点击日期选择器，选好初始时间和结束时间后，解除禁用限制
        this.selectData = 0;
      }
    },
    disabledDate: (time: any) => {
      if (!this.selectData) {
        const minTime = new Date().getTime() - 3600 * 1000 * 24 * 90;
        const maxTime = new Date().getTime() + 3600 * 1000 * 24 * 90;
        return time.getTime() <= minTime || time.getTime() >= maxTime;
      } else {
        return (
          time.getTime() < this.selectData - 3600 * 1000 * 24 ||
          time.getTime() > this.selectData + 3600 * 1000 * 24
        );
      }
    }
  };

  wxBgView = require("@/assets/ai-builder/wexinbg/view.png");
  wxBgDetail = require("@/assets/ai-builder/wexinbg/detail.png");
  wxBgFailure = require("@/assets/ai-builder/wexinbg/failure.png");
  wxBgBorder = require("@/assets/ai-builder/phone-border.png");

  qrFailureText = "您好，本场面试已结束，如有问题请联系企业招聘负责人";

  setDefVir() {
    this.defVir.imgUrl =
      "https://oss.hina.com/app/test/2023/04/27/4e1887e0ceeac997ef35c0b63ae34f42.png";
    this.defVir.imgUrl2 =
      "https://oss.hina.com/app/test/2023/04/27/cfa4e88884322bba78d8a445d52b59ac.png";
    this.defVir.imgUrl3 =
      "https://oss.hina.com/app/test/2023/04/27/e2bf600dc0f075ca745d3e4eba5106eb.png";
    this.defVir.name = "小娜";
  }
  diyChange(v: BeforeVideo[]) {
    this.$set(this.exam, "examVideoList", v);
    this.change();
  }

  // 是否展示面试过期提示设置块
  get showQrCodeFailure() {
    const flag = this.exam.noEnding === 2 || this.exam.timeLimitGiveUp !== -1;
    return flag;
  }

  atlessOne(n: any) {
    if (!n) {
      this.exam.photoConfig.numberLimit = 1;
      this.$forceUpdate();
    }
  }

  changeNeedSubmitPhoto() {
    if (this.exam.needSubmitPhoto === 2) {
      this.photoCheckSW = false;
    }
  }

  changePhotoCheck() {
    if (
      !this.exam.photoConfig.checkFaceAngle &&
      !this.exam.photoConfig.checkFaceComplete &&
      !this.exam.photoConfig.checkLighting
    ) {
      this.exam.photoConfig.errorBehavior = 0;
      this.photoCheckSW = false;
    }
    this.change();
  }

  photoCheckSW = false;
  photoCheckSWChange() {
    if (this.photoCheckSW) {
      this.exam.photoConfig.checkFaceAngle = true;
      this.exam.photoConfig.checkFaceComplete = true;
      this.exam.photoConfig.checkLighting = true;
      this.exam.photoConfig.errorBehavior = 0;
    } else {
      this.exam.photoConfig.checkFaceAngle = false;
      this.exam.photoConfig.checkFaceComplete = false;
      this.exam.photoConfig.checkLighting = false;
      this.exam.photoConfig.errorBehavior = 0;
    }
    this.change();
  }

  get virInfo() {
    // id为 3、4 新版直接用，
    // 1、2则转化 1 =>4， 2 =>3
    // 0旧数据用默认的defVir
    const id = this.exam.virVersion;
    const index = [3, 4].includes(id) ? id : id === 1 ? 4 : id === 2 ? 3 : 0;

    return this.virList.find(v => v.id === index) || this.defVir;
  }

  @Watch("exam", { deep: true })
  save(n: any, o: any) {
    //编辑时 数据加载完成后刷一次
    if (this.isEdit && !o.isAssigned && n.isAssigned) {
      this.setData();
      return;
    }
    this.change();
  }
  //切限制次数
  @Watch("repeatLimit", {})
  rp(n: any, o: any) {
    //不限制
    if (!n) {
      this.exam.repeatAnswerLimit = 100;
      // this.repeatLimitShow = 1;
    } else {
      //限制
      this.exam.repeatAnswerLimit = this.repeatLimitShow;
    }
  }
  //模拟练习开关
  @Watch("useTestExam", {})
  te(n: any, o: any) {
    if (n) {
      //开
      this.exam.testExamId = this.exam.testExamId
        ? this.exam.testExamId
        : this.testExamList?.[0]?.id;
    } else {
      this.exam.testExamId = 0;
    }
  }

  //限制次数的时间区间
  @Watch("exam.repeatAnswerDayLimit", { deep: true, immediate: true })
  timeLimitRule(n: any, o: any) {
    console.log(n);
    if (n) {
      this.exam.repeatAnswerDayLimit =
        Number(n) < 1 ? 1 : Number(n) > 365 ? 365 : Number(n);
    }
  }
  defaultBG =
    "https://oss.hina.com/app/hina/2021/07/10/3f1396a2ddd6a8493c582f22c69dae39.png";
  timeArr: string[] = [];
  ttt = "";
  upImgUrl = "";
  useDiyImg = 0; //使用默认图片封面
  regisList: Param[] = []; //所有字段list
  regisSelectedList: Param[] = []; //已选字段list
  showRegis = false; //弹窗 -字段
  editParam: any; //编辑体
  videoUrl = ""; //视频预览url
  videoUrlDef =
    "https://vod.hina.com/a3309d04251940faa56806be59bdf122/8c7be05066f64d29ae74ffbd5500daa9-ca173c7e0f3241eb8285dedda051a1ba-ld.mp4"; //视频预览url默认
  textDef1 =
    "海纳隶属于北京群星闪耀科技有限公司，致力于以AI技术赋能人力资源行业，帮助千千万万人才和企业做好人岗匹配、提升组织效率。拥有雄厚资本支持，可保证团队投入大量资金和人力到产品研发上，持续提升AI及产品能力，为大型集团提供可靠、持久的杰出服务。";
  textDef2 =
    "你好，我是本次面试的面试官，欢迎参加本公司的线上面试！面试预计需要10分钟，请你提前安排在网络良好、光线亮度合适、且相对安静的环境参加这次面试，以免影响本次面试的结果。如果你在面试过程中遇到问题，请与我们的招聘人员联系。";
  textDef3 =
    "感谢你参加面试，面试结果我们会在1-3个工作日内通知你。我们期待你的加入，再见！";
  repeatLimit = false;
  repeatLimitShow = 1; //限制面试次数 下拉展示用
  useTestExam = 0; //模拟练习 开关
  testExamList: TestExamList[] = [new TestExamList()];
  dataReady = false;
  regisSelectedBehindList: Param[] = []; //已选靠后字段
  regisSelectedFrontendList: Param[] = []; //已选字段list
  showBehindList = false; // 面试后登记信息开关
  collapseInd = 0;

  screenshotWhiteListOptions = [
    { label: "面试结束页", name: "finish", value: false },
    { label: "模拟练习页", name: "simulation-answer", value: false }
  ];
  showWatermark = false; // 水印开关
  screenshotAutoSubmitExam = false; // 截屏自动交卷开关
  jumpOutAutoSubmitExam = false; // 切屏自动交卷开关

  //提交前校验
  async checkData() {
    if (!this.needValidation) {
      this.needValidation = true;
    }
    if (this.validateMinute) return;
    //处理额外视频字段
    if (this.exam.examVideoList.length) {
      const lackInfo = this.exam.examVideoList.some(d => {
        //使用视频
        const lack1 = d.showWay === 1 && !d.videoUrl;
        //使用Ai朗读 或 文字
        const lack2 = [2, 5].includes(d.showWay) && !d.text;
        //使用图片
        const lack3 = [4].includes(d.showWay) && !d.videoCoverUrl;
        return lack1 || lack2 || lack3;
      });

      if (lackInfo) {
        this.$message.warning("请完善面试须知语的内容或图片/视频");
        return false;
      }

      for (let i = 0; i < this.exam.examVideoList.length; i++) {
        if (this.exam.examVideoList[i].showWay === 1) {
          await this.checkoutMediaWidthHeight(this.exam.examVideoList[i], i);
        }
      }
    }

    return true;
  }

  created() {
    //获取公司所有字段
    Params.get().then(res => {
      res.paramList.forEach((d: any) => {
        //新增时 选项存入个随机id
        for (let i = 0; i < d.singleChoiceOptions.length; i++) {
          d.fIdList.push(this.R());
        }
      });

      //首次直接扔缓存里，后续只与缓存io
      this.exam.paramList =
        this.exam.paramList.length > 1 ? this.exam.paramList : res.paramList;
      this.regisList = this.exam.paramList; //全部

      //已选 排序
      this.regisSelectedList = this.regisList
        .filter(res => res.isShow === 1)
        .sort((a: Param, b: Param) => Number(a.sort) - Number(b.sort));
      this.regisSelectedList.forEach(el => {
        if (el.saveLater === 0 || !el.saveLater) {
          this.regisSelectedFrontendList.push(el);
        }
        if (el.saveLater === 1) {
          this.regisSelectedBehindList.push(el);
        }
      });

      if (this.regisSelectedBehindList.length > 0) {
        this.showBehindList = true;
      }

      this.setDefVir();
      this.dataReady = true;
      this.setSwitch();
    });
  }
  miniProgress = 2;
  checkMiniProgress(val: number) {
    if (val === 1) {
      this.exam.newSectionProgressUi = 0;
      this.exam.newSectionProgressUiVersion = 0;
    }
    if (val === 2) {
      this.exam.newSectionProgressUi = 1;
      this.exam.newSectionProgressUiVersion = 0;
    }
    if (val === 3) {
      this.exam.newSectionProgressUi = 1;
      this.exam.newSectionProgressUiVersion = 1;
    }
  }
  checkMiniProgressBack() {
    if (
      this.exam.newSectionProgressUi === 0 &&
      this.exam.newSectionProgressUiVersion === 0
    ) {
      this.miniProgress = 1;
    }
    if (
      this.exam.newSectionProgressUi === 1 &&
      this.exam.newSectionProgressUiVersion === 0
    ) {
      this.miniProgress = 2;
    }
    if (
      this.exam.newSectionProgressUi === 1 &&
      this.exam.newSectionProgressUiVersion === 1
    ) {
      this.miniProgress = 3;
    }
  }

  mounted() {
    this.checkMiniProgressBack();
    //封面图片url 新建时初始化
    this.exam.publicityPageVideoCoverUrl =
      this.exam.publicityPageVideoCoverUrl || this.defaultBG;
    this.upImgUrl = this.exam.publicityPageVideoCoverUrl;
    //岗位描述 须知 结束 默认文案
    this.exam.publicityPageContent =
      this.exam.publicityPageContent || this.textDef1;
    this.exam.descBefore = this.exam.descBefore || this.textDef2;
    this.exam.descAfter = this.exam.descAfter || this.textDef3;
    this.exam.examExpireTextMessage =
      this.exam.examExpireTextMessage || this.qrFailureText;
    this.setData();
  }
  //是否选择题
  isSelectTypeQuestion(id: number): boolean {
    const QConfig = this.exam.examScoreConfigList.filter(q => {
      return q.questionId === id;
    });
    return Boolean(QConfig?.[0]?.choiceQuestionScoreList?.[0]?.content);
  }

  //是否填空题
  isBlankTypeQuestion(id: number): boolean {
    const QConfig = this.exam.examScoreConfigList.filter(q => {
      return q.questionId === id;
    });
    return Boolean(QConfig?.[0]?.blankQuestionScoreList[0]);
  }

  get validateMinute() {
    return this.exam.timeLimitExamType === 2 && !+this.exam.timeLimitExam;
  }

  //面试预计耗时
  get examTakeTime() {
    console.log(this.exam);
    let second = 0;
    if (this.exam.isRandomQuestions === 1) {
      // 抽题组卷
      this.exam.examRandomConfigList.forEach((questionGroup, index) => {
        // 抽题组卷根据每组配置的题目类型与抽题数量算时长
        const n = questionGroup.questionNumber;
        if (
          questionGroup.questionType === 1 ||
          questionGroup.questionType === 5
        ) {
          //选择填空题耗时  30s
          second += n * 30;
        } else {
          // 视频音频 同普通
          second += n * 30;
          second +=
            questionGroup.examQuestionConfig?.preparationTime > 0
              ? questionGroup.examQuestionConfig?.preparationTime
              : n * 10;
          second +=
            questionGroup.examQuestionConfig?.answerTime > 0
              ? questionGroup.examQuestionConfig?.answerTime
              : n * 3 * 60;
        }
      });
    } else {
      this.exam.examQuestionConfigList.forEach((q, i: number) => {
        if (
          this.isSelectTypeQuestion(q.questionId) ||
          this.isBlankTypeQuestion(q.questionId)
        ) {
          //选择题/填空题耗时  30s
          second += 1 * 30;
        } else {
          //视频题耗时  题干30s 其他看配置
          second += 1 * 30;
          second += q?.preparationTime > 0 ? q?.preparationTime : 1 * 10;
          second += q?.answerTime > 0 ? q?.answerTime : 3 * 60;
        }
      });
    }
    //各类配置耗时
    second += this.exam.colorTest === 1 ? 1 * 60 : 0;
    second += this.exam.psycGaugeConfig.psycGaugeId !== 0 ? 5 * 60 : 0;
    second += this.exam.gameTestConfig[0] !== 0 ? 1 * 60 : 0;
    second += this.exam.fingerTest === 1 ? 1 * 60 : 0;
    second += this.exam.bgCheckProductId !== 0 ? 1 * 10 : 0;
    second += this.exam.livenessRecognition === 1 ? 1 * 60 : 0;
    const minutes = Math.ceil(second / 60);
    return minutes;
  }
  //视频是否解码完成
  get videoReady() {
    return (
      this.exam.publicityPageVideoUseWhich === 2 &&
      this.exam.publicityPageVideoUrl
    );
  }

  //计算长度
  get ww() {
    const t: any = this.testExamList.find(d => d.id === this.exam.testExamId);
    return (t?.name?.length ?? 5) * 14 + 55;
  }
  //选项ID生成
  R() {
    return String((Math.random() * 10000000000).toFixed(0));
  }

  //exam回显数据
  setData() {
    this.timeArr = [this.exam.beginTime, this.exam.endTime]; //编辑回显时间段
    //封面图片url
    this.exam.publicityPageVideoCoverUrl =
      this.exam.publicityPageVideoCoverUrl || this.defaultBG;
    this.upImgUrl = this.exam.publicityPageVideoCoverUrl;
    //封面图片是否diy
    this.useDiyImg =
      this.exam.publicityPageVideoCoverUrl === this.defaultBG ? 0 : 1;
    //自定义封面视频
    this.exam.publicityPageVideoUrl =
      this.exam.publicityPageVideoUseWhich === 2
        ? this.exam.publicityPageVideoUrl
        : "";
    this.exam.publicityPageVideoId =
      this.exam.publicityPageVideoUseWhich === 2
        ? this.exam.publicityPageVideoId
        : "";
    this.videoUrl = this.exam.publicityPageVideoUrl;
    //限制面试次数
    const isLimit = this.exam.repeatAnswerLimit !== 100;
    this.repeatLimit = isLimit ? true : false;
    this.repeatLimitShow = isLimit ? this.exam.repeatAnswerLimit : 1;

    this.showWatermark = this.exam.watermarkType > 0;
    this.screenshotAutoSubmitExam = this.exam.screenshotCheckLimit > 0;
    this.jumpOutAutoSubmitExam = this.exam.mobileJoinCountCheckLimit > 0;

    //模拟练习
    this.useTestExam = this.exam.testExamId !== 0 ? 1 : 0;
    //答题时间限制
    // this.timeLimitExamType = this.exam.timeLimitExam === 86400 ? 1 : 2;
    this.exam.timeLimitExam =
      this.exam.timeLimitExam === 86400 ? 0 : this.exam.timeLimitExam;
    // ?  / 60
    // : this.exam.timeLimitExam; //默认 或 秒转分
    //题目乱序
    if (this.exam.questionRandomSort === 1) {
      //开 判下边界
      this.exam.questionRandomSortRange[1] = Math.min(
        this.exam.questionRandomSortRange[1],
        this.exam.questionIdList.length
      );
    } else {
      //关
      this.exam.questionRandomSortRange = [1, this.exam.questionIdList.length];
    }
    if (
      this.exam.photoConfig.checkFaceAngle === true ||
      this.exam.photoConfig.checkFaceComplete === true ||
      this.exam.photoConfig.checkLighting === true
    ) {
      this.photoCheckSW = true;
    } else {
      this.photoCheckSW = false;
    }
    this.getTestExam(); //模拟练习
  }

  //已选字段排序sort
  sortSelected() {
    this.regisSelectedList.forEach((d, i) => {
      d.sort = i + 1;
    });

    this.exam.paramList = this.regisList;
    this.change();
  }
  sortBehindSelected() {
    this.regisSelectedList = [
      ...this.regisSelectedFrontendList,
      ...this.regisSelectedBehindList
    ];
    this.regisSelectedList.forEach((d, i) => {
      d.sort = i + 1;
    });
    this.exam.paramList = this.regisList;
    this.change();
  }
  sortFrontSelected() {
    this.regisSelectedList = [
      ...this.regisSelectedFrontendList,
      ...this.regisSelectedBehindList
    ];
    this.regisSelectedList.forEach((d, i) => {
      d.sort = i + 1;
    });
    this.exam.paramList = this.regisList;
    this.change();
  }
  //模拟练习
  getTestExam() {
    ExamList.getTestExams().then(res => {
      if (res.code === 0) {
        if (res.data.length) {
          this.testExamList = res.data;
          if (this.useTestExam) {
            this.exam.testExamId = this.exam.testExamId
              ? this.exam.testExamId
              : res.data?.[0]?.id;
          } else {
            this.exam.testExamId = 0;
          }
        }
      }
    });
  }
  getSeletOptions(type: number) {
    const list = this.regisList.filter(
      el => el.saveLater == type && el.inputType !== "zmnStore"
    );
    return list;
  }
  //选择
  select(item: Param) {
    const i = this.regisSelectedList.findIndex(
      (d: Param) => d.name === item.name
    );
    item.isShow = item.isShow === 1 ? 2 : 1;
    if (i !== -1) {
      //取消
      this.regisSelectedList.splice(i, 1);
      this.$forceUpdate();
    } else {
      //选中
      if (item.inputType !== "shortIdCard" && item.inputType !== "idcard") {
        this.regisSelectedList.push(item);
        this.$forceUpdate();
      } else {
        const i = this.regisSelectedList.findIndex(
          d => d.inputType === "shortIdCard"
        );
        console.log(i, item.inputType === "idcard", item.inputType);
        if (i == -1 && item.inputType === "idcard") {
          console.log("aaaaaaaaaa");
          this.regisSelectedList.splice(2, 0, item);
        } else {
          enum num {
            "shortIdCard" = 2,
            "idcard" = 3
          }
          //身份后六 固定第三
          this.regisSelectedList.splice(num[item.inputType], 0, item);
          this.$forceUpdate();
        }
      }
    }
    this.updateTowList();
    this.sortSelected();
    this.$forceUpdate();
  }
  updateTowList() {
    this.regisSelectedFrontendList = [];
    this.regisSelectedBehindList = [];
    this.regisSelectedList.forEach(el => {
      if (el.saveLater === 0 || !el.saveLater) {
        this.regisSelectedFrontendList.push(el);
      }
      if (el.saveLater === 1) {
        this.regisSelectedBehindList.push(el);
      }
    });
    this.$forceUpdate();
  }
  addRegis(flag: number) {
    this.editParam = undefined;
    this.showRegis = true;
    if (flag) {
      this.$nextTick(() => {
        const RegisEdit = this.$refs.RegisEdit as any;
        RegisEdit.formData.saveLater = 1;
      });
    }
  }

  showBehindListChange(value: any) {
    if (value && !this.regisSelectedBehindList.length) {
      this.collapseInd = 1;
    }
  }

  editRegis(item: Param) {
    console.log(item, "item");
    this.editParam = item;
    this.showRegis = true;
  }
  //字段确认  params:更新后数据   edit:更新前数据
  editOk(params: Param, edit: any) {
    const n = this.regisList.find(d => d.name === params.name);
    if (n && n?.paramIndex !== params.paramIndex) {
      this.$message.warning("字段名称不能重复");
      return;
    }
    if (edit) {
      //编辑
      this.regisList.splice(Number(edit.paramIndex) - 1, 1, params);
      const i = this.regisSelectedList.findIndex(
        d => d.paramIndex === edit.paramIndex
      );
      if (i !== -1) {
        this.regisSelectedList.splice(i, 1, params);
      }
    } else {
      //新增
      params.paramIndex = this.regisList.length + 1;
      params.isShow = 1;
      this.regisList.push(params);
      // this.select(params)
      this.regisSelectedList.push(params); //直接选中
      this.sortSelected();
    }
    this.exam.paramList = this.regisList;
    this.updateTowList();
    this.change();
    this.showRegis = false;
  }
  editClose() {
    this.showRegis = false;
  }
  //根据测评配置，设置对应字段
  setSwitch() {
    //人脸开启 跟随选中身份证字段
    if (this.exam.livenessRecognition === 1) {
      this.setIdCard(1);
    }
    //使用背调  开启身份证 和 验证码
    this.setIdCardAndPhoneMessage(this.exam.bgCheckProductId);
  }
  //人脸开启 跟随选中身份证字段
  setIdCard(e: any) {
    if (e !== 1) return;
    const i = this.regisList.findIndex(d => d.name === "身份证号");
    if (i !== -1 && this.regisList[i].isShow !== 1) {
      this.regisList[i].isRequired = 1;
      this.select(this.regisList[i]);
    }
  }
  //使用背调  开启身份证 和 验证码
  setIdCardAndPhoneMessage(e: any) {
    if (e === 0) return;
    this.setIdCard(1);
    this.exam.captchaCheck = 1;
    this.change();
  }

  //上传图片
  uploaded(d: any) {
    this.upImgUrl = d;
    this.exam.publicityPageVideoCoverUrl = this.upImgUrl;
    (this.$refs.carousel1 as any)?.setActiveItem(0);
    this.change();
    //
  }

  //上传须知语图片
  uploadedBeforeImg(d: any) {
    this.exam.descBeforeShowWayImgUrl = d;
    (this.$refs.carousel2 as any)?.setActiveItem(0);
    this.change();
  }
  //上传结束语图片
  uploadedAfterImg(d: any) {
    this.exam.descAfterShowWayImgUrl = d;
    (this.$refs.carousel2 as any)?.setActiveItem(1);
    this.change();
  }

  //获取选择的本地频播放url
  getVideoUrl(url: string) {
    // this.videoUrl = url;
    //
  }
  //上传成功后 视频id 已弃用
  // setVideoId(id: string) {
  //   this.exam.publicityPageVideoId = id;
  // }
  //上传成功后 视频url
  setVideoUrl(url: string) {
    this.exam.publicityPageVideoUrl = url;
    this.videoUrl = url;
    this.change();
  }
  // 时间设置变化
  noEndingChange(label: number) {
    // if (label !== 1) {
    //   console.log(label);
    //   this.showPopMessage =
    //     "当前答题时间限制为固定期限范围内,如需修改请设置面试时间的其他选项";
    // } else {
    //   this.showPopMessage = "此面试有效期为长期有效，无法设置此选项";
    // }
  }
  //添加额外须知语
  addBeforeVideo() {
    this.exam.examVideoList.push(new BeforeVideo());
  }
  delBeforeVideo(i: number) {
    this.exam.examVideoList.splice(i, 1);
  }
  //切屏
  prev(i: number) {
    (this.$refs["carousel" + i] as any)?.prev();
  }
  next(i: number) {
    (this.$refs["carousel" + i] as any)?.next();
  }
  //拖
  onMove() {
    //
  }
  voiceChange() {
    this.exam.repeatAnswerAuditStatusPassLimit = false;
    this.exam.repeatAnswerAuditStatusWaitLimit = false;
    this.exam.repeatAnswerAuditStatusRefuseLimit = false;
    this.exam.repeatAnswerAuditStatusNormalLimit = false;
  }
  //乱序起止
  setQStart() {
    const t = this.exam.questionRandomSortRange;
    if (Number(t[0]) >= Number(t[1])) {
      this.exam.questionRandomSortRange.splice(0, 1, Number(t[1]) - 1);
    }
  }
  setQEnd() {
    const t = this.exam.questionRandomSortRange;
    if (Number(t[1]) <= Number(t[0])) {
      this.exam.questionRandomSortRange.splice(1, 1, Number(t[0]) + 1);
    }
  }

  // 防截屏限制
  setScreenshot(value: string, operate: string) {
    if (!this.setWeb && Number(value) === 1) {
      this.exam.screenshotCheckLimit = operate === "up" ? 2 : 0;
    } else if (isNaN(Number(value))) {
      this.exam.screenshotCheckLimit = 2;
    } else if (Number(value) === 0) {
      this.exam.screenshotCheckLimit = 0;
    } else if (Number(value) < 2) {
      this.exam.screenshotCheckLimit = 2;
    } else if (Number(value) > 999) {
      this.exam.screenshotCheckLimit = 999;
    } else {
      this.exam.screenshotCheckLimit = Number(value);
    }
  }

  // 防切屏限制
  setMobileJoin(value: string, operate: string) {
    if (!this.setWeb && Number(value) === 1) {
      this.exam.mobileJoinCountCheckLimit = operate === "up" ? 2 : 0;
    } else if (isNaN(Number(value))) {
      this.exam.mobileJoinCountCheckLimit = 2;
    } else if (Number(value) === 0) {
      this.exam.mobileJoinCountCheckLimit = 0;
    } else if (Number(value) < 2) {
      this.exam.mobileJoinCountCheckLimit = 2;
    } else if (Number(value) > 999) {
      this.exam.mobileJoinCountCheckLimit = 999;
    } else {
      this.exam.mobileJoinCountCheckLimit = Number(value);
    }
  }

  filterTime(val: any) {
    this.needValidation = true;
    val = val.replace(/\D/g, "");
    this.exam.timeLimitExam =
      0 <= val && val < 100000 ? val : val > 99999 ? 99999 : 0;
  }
  encodeCandidateInfoChange(value: number) {
    if (value === 2) {
      this.exam.encodeTypeConnectCode = 0;
      this.exam.encodeTypeBaseInfo = 0;
      this.exam.encodeTypeOtherInfo = 0;
    }
  }
  @Emit()
  change() {
    return;
  }
  //是否条件字段
  showOp(item: any) {
    return item?.showConfigList?.[0]?.[0]?.matchParamIndex;
  }
  //条件展示文案
  showOpText(item: any) {
    const fa = this.regisList.find((d: any) => {
      return d.paramIndex == item.showConfigList?.[0]?.[0]?.matchParamIndex;
    });
    let t = ``;
    fa?.fIdList.forEach((d: any, i: number) => {
      item.showConfigList.forEach((m: any, n: number) => {
        if (d == m[0].fId) {
          t += `[${fa.singleChoiceOptions[i] || fa.mutiChoiceOptions[i].key}] `;
        }
      });
    });
    return { name: fa?.name, text: t };
  }
  //检查图片视频的宽高比例
  async checkoutMediaWidthHeight(it: BeforeVideo, index: number) {
    if (it.showWay === 4 && it.videoCoverUrl) {
      //图片
      return new Promise((resolve, reject) => {
        const img = document.createElement("img");
        img.onload = () => {
          //
          const width = img.width;
          const height = img.height;
          // this.exam.examVideoList[index].fillType = width > height ? 0 : 1;
          this.$set(
            this.exam.examVideoList[index],
            "fillType",
            width > height ? 0 : 1
          );
          this.change();
          resolve(true);
        };
        img.src = it.videoCoverUrl;
      });
    } else {
      //视频在上传时已处理
      return;
    }
  }
  repeatLimitShowChange(value: any) {
    console.log(
      value,
      "repeatLimitShowChangerepeatLimitShowChangerepeatLimitShowChange"
    );
    this.exam.repeatAnswerLimit = Number(value);
  }
}
